import { CompensationCycleData } from './types';

export const COMPENSATION_CYCLES_DATA: CompensationCycleData[] = [
  {
    id: 1,
    cycleName: 'Comp cycle - annual 2024',
    preset: 'Performance based',
    status: 'ACTIVE',
    launchDate: 'Jan 1, 2025',
  },
  {
    id: 2,
    cycleName: 'Comp cycle - mid year 2024',
    preset: 'Independent',
    status: 'DRAFT',
    launchDate: 'Jan 1, 2025',
  },
  {
    id: 3,
    cycleName: 'Comp cycle - annual 2023',
    preset: 'Market correction',
    status: 'ACTIVE',
    launchDate: 'Jan 1, 2025',
  },
  {
    id: 4,
    cycleName: 'Comp cycle - mid year 2023',
    preset: 'Performance based',
    status: 'COMPLETED',
    launchDate: 'Jan 1, 2025',
  },
  {
    id: 5,
    cycleName: 'Comp cycle - annual 2022',
    preset: 'Independent',
    status: 'DRAFT',
    launchDate: 'Jan 1, 2025',
  },
  {
    id: 6,
    cycleName: 'Comp cycle - mid year 2022',
    preset: 'Performance based',
    status: 'DRAFT',
    launchDate: 'Jan 1, 2025',
  },
];
